import { ProductDetail } from "Components/InsuranceDetailsCard/ProductDetailsTable/interface";
import { NumberValue, VALUE_TYPE } from "Components/NumberValue";
import { TextManager } from "Components/TextContext";
import { HouseProduct } from "Store/interfaces/products/checkout/riskProducts/houseProducts/HouseProduct";
import { isDefined } from "Utils/functions";
import React from "react";
import { YesOrNo } from "../../Boolean";
import {
  getHouseTypeDetail,
  getRentalStatusProductDetail,
  getYesOrNoText,
} from "../../utils";
import { AdditionalBuildingsHouseDetails } from "./AdditionalBuildingsHouseDetails";

export const houseDetailsList = (
  product: HouseProduct,
  featureToggleGeodata: boolean,
): ProductDetail[] => {
  const { getText } = TextManager;

  return [
    {
      name: getText("houseform.shorttitle.housetype"),
      value: getHouseTypeDetail(product.houseType),
    },
    {
      name: getText("houseform.shorttitle.constructionyear"),
      value: product.constructionYear,
    },
    {
      name: getText("houseform.shorttitle.isroofchanged"),
      value: getYesOrNoText(product?.isRoofChanged),
      hidden: !isDefined(product.isRoofChanged),
    },
    {
      name: getText("houseform.shorttitle.iswetareasrehabilitatedorchanged"),
      value: getYesOrNoText(product?.isWetAreasRehabilitatedOrChanged),
      hidden: !isDefined(product.isWetAreasRehabilitatedOrChanged),
    },
    {
      name: getText(
        "houseform.shorttitle.iswithhistoryofwaterormoisturedamage",
      ),
      value: getYesOrNoText(product?.isWithHistoryOfOfWaterOrMoistureDamage),
      hidden: !isDefined(product.isWithHistoryOfOfWaterOrMoistureDamage),
    },
    {
      name: getText("houseform.shorttitle.hasbasementroom"),
      value: getYesOrNoText(product?.hasBasementRoom),
      hidden: featureToggleGeodata,
    },
    {
      name: getText("houseform.shorttitle.pestsdamaged"),
      value: getYesOrNoText(product?.previousFungusDamage),
      hidden: !isDefined(product.previousFungusDamage),
    },
    getRentalStatusProductDetail(product),
    {
      name: getText("houseform.shorttitle.bta"),
      value: (
        <NumberValue
          value={product.grossArea}
          type={VALUE_TYPE.SQUARE_METERS}
        />
      ),
    },
    {
      name: getText("houseform.shorttitle.bra"),
      value: (
        <NumberValue
          value={product.livingFloorSpace}
          type={VALUE_TYPE.SQUARE_METERS}
        />
      ),
    },
    {
      name: getText("houseform.shorttitle.firstriskinsuranceamount"),
      value: <NumberValue value={product.firstRiskSum} type={VALUE_TYPE.NOK} />,
      hidden: !isDefined(product.firstRiskSum),
    },
    {
      name: getText("houseform.shorttitle.hasburglaralarm"),
      value: (
        <YesOrNo value={product.hasBurglarAlarm ?? product.hasAlarm ?? false} />
      ),
    },
    {
      name: getText("houseform.shorttitle.hasfirealarm"),
      value: <YesOrNo value={product.hasFireAlarm} />,
      hidden:
        !isDefined(product.fireAlarmCode) && !isDefined(product.hasFireAlarm),
    },
    {
      name: getText("houseform.shorttitle.haswaterguard"),
      value: <YesOrNo value={product.hasWaterGuard} />,
    },
    {
      name: getText("houseform.shorttitle.hascircuitbreakers"),
      value: <YesOrNo value={product.hasCircuitBreakers} />,
      hidden: !isDefined(product.hasCircuitBreakers),
    },
    {
      name: getText("houseform.shorttitle.haspipeinpipesystem"),
      value: <YesOrNo value={product.hasPipeInPipeSystem} />,
      hidden: !isDefined(product.hasPipeInPipeSystem),
    },
    {
      name: getText("houseform.shorttitle.injuries"),
      value: product.damageCountRecentYears ?? 0,
    },
    {
      name: getText("houseform.shorttitle.injuryyear"),
      value: product.yearOfLastDamage,
      hidden: product.damageCountRecentYears === 0,
    },
    {
      name: getText("houseform.shorttitle.additionalbuildings"),
      value:
        product.additionalBuildings.length > 0 ? (
          <AdditionalBuildingsHouseDetails product={product} />
        ) : (
          getText(
            "houseform.shortvalue.additionalbuildings-noadditionalbuilding",
          )
        ),
    },
    {
      name: getText("houseform.shorttitle.insuranceadditionalbuilding"),
      value:
        product.additionalBuildings.length > 0
          ? product.additionalBuildings[0].coverage
          : "??",
      hidden: product.additionalBuildings.length === 0,
    },
    {
      name: getText("houseform.shorttitle.maintenanceconfirmation"),
      value: <YesOrNo value={product.maintenanceConfirmation} />,
    },
  ];
};
